const connectCheckMixin = {
  data() {
    return {
      // ブラウザは上手く接続状況を取得してくれないので、スマホの場合のみ判定する
      isOnLine: navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/) ? navigator.onLine : true,
    }
  },
  created() {
    // ネットワークの接続状況をリアルタイムで取得
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
      window.addEventListener('online', this.updateConnectionStatus)
      window.addEventListener('offline', this.updateConnectionStatus)
    }
  },
  methods: {
    updateConnectionStatus() {
      this.isOnLine = window.navigator.onLine
    },
  },
}

export default connectCheckMixin



// WEBPACK FOOTER //
// ./src/mixins/connectCheckMixin.js